var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDok1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1376,
    height: 418,
    viewBox: "0 0 1376 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.324 0H0V417.728H192.324C309.964 417.728 405.32 322.359 405.32 204.732C405.32 87.0922 309.95 0 192.324 0ZM215.069 227.477H169.565V181.987H215.055V227.477H215.069Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M647.276 0C531.926 0 438.412 93.5134 438.412 208.864C438.412 324.215 531.926 417.728 647.276 417.728C762.627 417.728 856.141 324.215 856.141 208.864C856.141 93.5134 762.627 0 647.276 0ZM670.021 231.609H624.531V186.119H670.021V231.609Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M893.545 0V417.728H1094.99V272.968H1112.57L1173.33 417.728H1376L1288.96 208.864L1376 0H1171.74L1110.5 142.688H1093.96V0H893.545Z",
    fill: "#D3D3D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDok1);
export default __webpack_public_path__ + "static/media/Dok1.fa722e311107390f9f687ca3a0179cbc.svg";
export { ForwardRef as ReactComponent };